// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "babel-polyfill";
import promise from "es6-promise";
promise.polyfill();
import App from "./App";
import router from "./router";
import store from "./store/index.js";

//element
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

// 公共样式
import "@/assets/css/style.scss";

import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";

//过滤器
import * as filter from "./filters/filters.js";

//公共样式
// require('@/assets/css/common.css');
//字体样式
require("@/assets/fonts/iconfont.css");
import axios from "axios";


//工具
import U from "@/api/utils.js";
Vue.prototype.U = U;
import UT from "@/api/utilsT.js";
Vue.prototype.UT = UT;

//路由全局守卫
router.beforeEach((to, from, next) => {
  axios({
    method: 'get',
    url: `/static/version.json?t=${new Date().getTime()}`,
  }).then(res => {
    if (res.status == 200) {
      let version = res.data.version
      let localVersion = localStorage.getItem('version');
      console.log(localVersion, '本地版本数据localVersion前');
      console.log(version, '线上版本数据version前');
      if ((localVersion && localVersion != version)) {
        console.log(localVersion, '本地版本数据localVersion后');
        console.log(version, '线上版本数据version后');
        if (confirm("系统检测到有新版本，是否更新？")) {
          localStorage.setItem('version', res.data.version);
          window.location.reload();
          return;
        }
      } else {
        localStorage.setItem('version', res.data.version);
      }
    }
  })
  if (
    to.path != "/" &&
    to.path != "/ApplyForJoining" &&
    to.path != "/product" &&
    to.path != "/Register" &&
    to.path != "/ForgetPass" &&
    to.path != "/corelDrawLogin" &&
    !sessionStorage.getItem("loginInfo")
  ) {
    next("/");
  } else {
    next();
  }
});

/* eslint-disable no-new */
const vm = new Vue({
  el: "#app",
  router,
  store,
  components: {
    App,
    Swiper
  },
  template: "<App/>"
});
export {
  vm,
  router,
  store
};



// WEBPACK FOOTER //
// ./src/main.js